// extracted by mini-css-extract-plugin
export default {"report":"PowerBiReport_report__X9btu","loading":"PowerBiReport_loading__+a-gM","basicLoader":"PowerBiReport_basicLoader__kgxYo"};